export default __webpack_public_path__ + "static/sp-action-button-c6e6ffbe102baae6a70116f46d4cf86a.png";